import dayjs from "dayjs";

const SUPPLIER_REPORTING_WINDOW_HOURS = 48;
export const SUPPLIER_MIN_PHOTOS = 3;

export function isWithinSupplierReportingWindow(
  driverDeliveredAt: string | null | undefined,
) {
  if (!driverDeliveredAt) {
    return false;
  }

  return (
    dayjs().diff(dayjs.utc(driverDeliveredAt), "hour", true) <=
    SUPPLIER_REPORTING_WINDOW_HOURS
  );
}
